import { IReferenceData } from 'src/app/shared/interfaces/form/reference-data.model';

export interface RelatedServiceData {
    schoolType: number;
    languageId: number;
    disciplineId: number;
    borough: number;
    district: number;
    awardedTierId: number;
    awardedPrice: string | null;
    orderOfUse: string | null;
    dateRange: string | null;
}

export interface RelatedServiceReferenceData {
    schoolTypeDropdown: IReferenceData[];
    languageDropdown: IReferenceData[];
    disciplineDropdown: IReferenceData[];
    boroughDropdown: IReferenceData[];
    districtDropdown: IReferenceData[];
    awardedTierDropdown: IReferenceData[];
}

export class ExportRelatedService {
    schoolType: string;
    languageId: string;
    disciplineId: string;
    borough: string;
    district: string;
    awardedTierId: string;
    awardedPrice: string | null;
    orderOfUse: string | null;
    dateRange: string | null;


    constructor(data: RelatedServiceData, referenceData: RelatedServiceReferenceData) {
        this.schoolType = this.dropdownData(data?.schoolType, referenceData?.schoolTypeDropdown)?.description;
        this.languageId = this.dropdownData(data?.languageId, referenceData?.languageDropdown)?.description;
        this.disciplineId = this.dropdownData(data?.disciplineId, referenceData?.disciplineDropdown)?.description;
        this.borough = this.dropdownData(data?.borough, referenceData?.boroughDropdown)?.description;
        this.district = this.dropdownData(data?.district, referenceData?.districtDropdown)?.description;
        this.awardedTierId = this.dropdownData(data?.awardedTierId, referenceData?.awardedTierDropdown)?.description;
        this.awardedPrice = data?.awardedPrice;
        this.orderOfUse = data?.orderOfUse;
        this.dateRange = data?.dateRange;
    }
    dropdownData(id: number, dropDownName: IReferenceData[]): IReferenceData | undefined {
        return dropDownName?.find((x: IReferenceData) => x.id === id);
    }
}
